import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useOrganization } from 'contexts/organization'
import { getIntegrationUrl } from 'utilities/url'
import {
    Instance,
    Meta, Name,
    StatusLabel, FakeButton,
    Arrow
} from './s'
import MetaText from 'components/meta'
import data from 'pages/integrations/pages/integration/data'

const IntegrationInstance = ({ instance }) => {
    const { organization } = useOrganization()

    const {
        name,
        status,
        type
    } = instance

    const { icon: Icon } = data?.[type]?.() ?? {}

    return (
        <Instance to={getIntegrationUrl(instance)}>
            {!!Icon && <Icon size={24} />}
            <Meta>
                <Name>{name}</Name>
                <MetaText
                    type="for"
                    by={instance.group?.name ?? organization?.name}
                    className="small compact" />
            </Meta>
            <StatusLabel status={status} />
            <FakeButton>
                <FormattedMessage
                    id="action_view_details"
                    defaultMessage="View details" />
            </FakeButton>
            <Arrow size={24} />
        </Instance>
    )
}

export default IntegrationInstance